<template>
  <router-view />
</template>

<script>
export default {
  name: 'DemoView',
}
</script>
